import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/screening')({
  staticData: { title: 'Screening' },
});
